// The lowest layer: one JSON request to the API, no tokens involved.

export class ApiError extends Error {
    // status 0: the API couldn't be reached.
    public constructor(public readonly status: number, message?: string) {
        super(message ?? `The server answered ${status}`);
    }
}

export async function send<T>(method: string, path: string, body?: unknown, accessToken?: string): Promise<T> {
    const headers: Record<string, string> = {};
    if (body !== undefined) {
        headers['Content-Type'] = 'application/json';
    }
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }
    let response: Response;
    try {
        response = await fetch(`${API_BASE}${path}`, {
            method,
            headers,
            body: body === undefined ? undefined : JSON.stringify(body)
        });
    } catch {
        throw new ApiError(0, "Couldn't reach the server.");
    }
    if (!response.ok) {
        throw new ApiError(response.status);
    }
    const text = await response.text();
    return (text ? JSON.parse(text) : undefined) as T;
}
